import { render, staticRenderFns } from "./TourCountdown.vue?vue&type=template&id=547d22d3&scoped=true"
import script from "./TourCountdown.vue?vue&type=script&lang=js"
export * from "./TourCountdown.vue?vue&type=script&lang=js"
import style0 from "./TourCountdown.vue?vue&type=style&index=0&id=547d22d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547d22d3",
  null
  
)

export default component.exports